const hoverTransition = [
    //background transition
    // { 'name': 'fade', class: 'background', 'displayName': 'Fade', 'professionalPremium': true, id: '27' },
    // { 'name': 'back-pulse', class: 'background', 'displayName': 'Back pulse', 'professionalPremium': true, id: '44' },
    { 'name': 'sweep-to-left', class: 'background', 'displayName': 'Sweep to left', 'professionalPremium': false, id: '9' },
    // {'name': 'sweep-to-left', 'displayName': 'Sweep to left', 'professionalPremium': true, id: '28'},
    { 'name': 'sweep-to-right', class: 'background', 'displayName': 'Sweep to right', 'professionalPremium': false, id: '10' },
    // {'name': 'sweep-to-right', 'displayName': 'Sweep to right', 'professionalPremium': true, id: '43'},
    { 'name': 'sweep-to-top', class: 'background', 'displayName': 'Sweep to top', 'professionalPremium': true, id: '11' },
    { 'name': 'sweep-to-bottom', class: 'background', 'displayName': 'Sweep to bottom', 'professionalPremium': true, id: '45' },
    { 'name': 'bounce-to-right', class: 'background', 'displayName': 'Bounce to right', 'professionalPremium': true, id: '29' },
    { 'name': 'bounce-to-left', class: 'background', 'displayName': 'Bounce to left', 'professionalPremium': true, id: '46' },
    { 'name': 'bounce-to-top', class: 'background', 'displayName': 'Bounce to top', 'professionalPremium': true, id: '30' },
    { 'name': 'bounce-to-bottom', class: 'background', 'displayName': 'Bounce to bottom', 'professionalPremium': true, id: '12' },
    { 'name': 'radial-out', class: 'background', 'displayName': 'Radial out', 'professionalPremium': true, id: '47' },
    { 'name': 'rectangle-out', class: 'background', 'displayName': 'Rectangle out', 'professionalPremium': true, id: '13' },
    { 'name': 'shutter-in-horizontal', class: 'anti-hover', 'displayName': 'Shutter in horizontal', 'professionalPremium': true, id: '31' },
    { 'name': 'shutter-out-horizontal', class: 'background', 'displayName': 'Shutter out horizontal', 'professionalPremium': true, id: '48' },
    { 'name': 'shutter-in-vertical', class: 'anti-hover', 'displayName': 'Shutter in vertical', 'professionalPremium': true, id: '14' },
    { 'name': 'shutter-out-vertical', class: 'background', 'displayName': 'Shutter out vertical', 'professionalPremium': true, id: '32' },

    //transform transition
    { 'name': 'grow', class: 'transform', 'displayName': 'Grow', 'professionalPremium': true, id: '0' },
    { 'name': 'shrink', class: 'transform', 'displayName': 'Shrink', 'professionalPremium': true, id: '18' },
    { 'name': 'pulse', class: 'transform', 'displayName': 'Pulse', 'professionalPremium': true, id: '35' },
    { 'name': 'pulse-grow', class: 'transform', 'displayName': 'Pulse grow', 'professionalPremium': true, id: '1' },
    { 'name': 'pulse-shrink', class: 'transform', 'displayName': 'Pulse shrink', 'professionalPremium': true, id: '19' },
    { 'name': 'push', class: 'transform', 'displayName': 'Push', 'professionalPremium': true, id: '36' },
    { 'name': 'pop', class: 'transform', 'displayName': 'Pop', 'professionalPremium': true, id: '2' },
    { 'name': 'bounce-in', class: 'transform', 'displayName': 'Bounce in', 'professionalPremium': true, id: '50' },
    { 'name': 'bounce-out', class: 'transform', 'displayName': 'Bounce out', 'professionalPremium': true, id: '20' },
    { 'name': 'rotate', class: 'transform', 'displayName': 'Rotate', 'professionalPremium': true, id: '37' },
    { 'name': 'grow-rotate', class: 'transform', 'displayName': 'Grow rotate', 'professionalPremium': true, id: '3' },
    { 'name': 'float', class: 'transform', 'displayName': 'Float', 'professionalPremium': true, id: '21' },
    { 'name': 'sink', class: 'transform', 'displayName': 'Sink', 'professionalPremium': true, id: '38' },
    { 'name': 'bob', class: 'transform', 'displayName': 'Bob', 'professionalPremium': true, id: '4' },
    { 'name': 'hang', class: 'transform', 'displayName': 'Hang', 'professionalPremium': true, id: '22' },
    { 'name': 'skew', class: 'transform', 'displayName': 'Skew', 'professionalPremium': true, id: '39' },
    { 'name': 'skew-forward', class: 'transform', 'displayName': 'Skew forward', 'professionalPremium': true, id: '5' },
    { 'name': 'skew-backward', class: 'transform', 'displayName': 'Skew backward', 'professionalPremium': true, id: '23' },
    { 'name': 'wobble-horizontal', class: 'transform', 'displayName': 'Wobble horizontal', 'professionalPremium': true, id: '6' },
    { 'name': 'wobble-vertical', class: 'transform', 'displayName': 'Wobble vertical', 'professionalPremium': true, id: '40' },
    { 'name': 'wobble-to-top-right', class: 'transform', 'displayName': 'Wobble to top right', 'professionalPremium': true, id: '41' },
    { 'name': 'wobble-to-bottom-right', class: 'transform', 'displayName': 'Wobble to bottom right', 'professionalPremium': true, id: '24' },
    { 'name': 'wobble-top', class: 'transform', 'displayName': 'Wobble top', 'professionalPremium': true, id: '7' },
    { 'name': 'wobble-bottom', class: 'transform', 'displayName': 'Wobble bottom', 'professionalPremium': true, id: '25' },
    { 'name': 'wobble-skew', class: 'transform', 'displayName': 'Wobble skew', 'professionalPremium': true, id: '42' },
    { 'name': 'buzz', class: 'transform', 'displayName': 'Buzz', 'professionalPremium': true, id: '26' },
    { 'name': 'buzz-out', class: 'transform', 'displayName': 'Buzz out', 'professionalPremium': true, id: '8' },


    //border transition
    // {'name': 'hollow', 'displayName': 'Hollow', 'professionalPremium': true, id: '49'},
    // {'name': 'round-corners', 'displayName': 'Round corners', 'professionalPremium': true, id: '15'},



    //shadow transition
    // { 'name': 'shadow', class: 'shadow', 'displayName': 'Shadow', 'professionalPremium': true, id: '33' },
    // { 'name': 'shadow-radial', class: 'shadow', 'displayName': 'Shadow radial', 'professionalPremium': true, id: '17' },
    // { 'name': 'box-shadow-inset', class: 'shadow', 'displayName': 'Box shadow inset', 'professionalPremium': true, id: '34' },
    // { 'name': 'box-shadow-outset', class: 'shadow', 'displayName': 'Box shadow outset', 'professionalPremium': true, id: '16' },
    // { 'name': 'float-shadow', class: 'shadow', 'displayName': 'Float shadow', 'professionalPremium': true, id: '51' },


    // {'name': '', 'displayName': 'None', 'professionalPremium': true, id: '32'},
];

export const iconAnimations = [
    {
        "value": "back",
        "label": "Icon-back"
    },
    {
        "value": "forward",
        "label": "Icon-forward"
    },
    {
        "value": "down",
        "label": "Icon-down"
    },
    {
        "value": "spin",
        "label": "Icon-spin"
    },
    {
        "value": "drop",
        "label": "Icon-drop"
    },
    // {
    //   "value": "fade",
    //   "label": "Icon-fade"
    // },
    {
        "value": "float-away",
        "label": "Icon float-away"
    },
    {
        "value": "sink-away",
        "label": "Icon sink-away"
    },
    {
        "value": "grow",
        "label": "Icon-grow"
    },
    {
        "value": "shrink",
        "label": "Icon-shrink"
    },
    {
        "value": "pulse",
        "label": "Icon-pulse"
    },
    {
        "value": "push",
        "label": "Icon-push"
    },
    {
        "value": "pop",
        "label": "Icon-pop"
    },
    {
        "value": "bounce",
        "label": "Icon-bounce"
    },
    {
        "value": "rotate",
        "label": "Icon-rotate"
    },
    {
        "value": "float",
        "label": "Icon-float"
    },
    {
        "value": "sink",
        "label": "Icon-sink"
    },
    {
        "value": "bob",
        "label": "Icon-bob"
    },
    {
        "value": "hang",
        "label": "Icon-hang"
    },
    {
        "value": "buzz",
        "label": "Icon-buzz"
    },
    {
        "value": "buzz-out",
        "label": "Icon buzz-out"
    },
    {
        "value": "wobble-horizontal",
        "label": "Icon wobble-horizontal"
    },
    {
        "value": "wobble-vertical",
        "label": "Icon wobble-vertical"
    }
]



export default hoverTransition;